import React, { useState } from "react";
import { Box, Modal, Paper, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Carousel } from 'primereact/carousel';
import Slider from "react-slick";
import ReactPanallumVr from "./ReactPanallumVr";
import MyServices from "./ServicesComponent/MyServices";



const ServicesCard = ({ service }) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    // autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
    const responsiveOptions = [
        {
            breakpoint: '1199px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '991px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '767px',
            numVisible: 1,
            numScroll: 1
        }
    ];
    const itemTemplate = (product) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                <img src={product} style={{ maxWidth: "95%", maxHeight: "300px" }}  onClick={() => handleOpen(product)} alt='top architects consultant in tirunelveli' />
            </div>
        );
    };
    return (
      <>
        <Paper elevation={3} className='p-4 mt-4'>
            <Typography variant='h4' component="h6" fontWeight={"bold"} >{service.name}</Typography>
            <Box className='mt-4'>
            <Typography variant='h6' component="h6">{service.subTitle}</Typography>
                <ul>
                    {service?.points?.map((point,idx) => {
                       return  <li key={idx}>{point}</li>
                    })}
                </ul>
                <p>
                    {service.description}
                </p>


                {/* <Carousel
                    value={service.images}
                    numVisible={3}
                    numScroll={3}
                    responsiveOptions={responsiveOptions}
                    className="custom-carousel"
                    circular
                    // autoplayInterval={3000} 
                    itemTemplate={itemTemplate} /> */}
                    {/* <MyServices/> */}
                     <Slider {...settings}>
      {service?.name === '360 Interior' ? service.images.map((data,idx)=>{
                let image = {
                    name:service.name,
                    img:data
                } 
                return <ReactPanallumVr key={idx} image={image} idx={idx}/>
            }) :
            service.images.map((data,idx)=>{
                return<Box padding={'10px'}> {itemTemplate(data)}</Box>
            })
      }
            </Slider>

            </Box>

        </Paper>
        {/* <Modal open={open} onClose={handleClose}>
        <Box 
          className="d-flex align-items-center justify-content-center" 
          sx={{    
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            width: "auto",
            maxWidth: "90%",
            maxHeight: "90%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            scroll: "auto",
            maxHeight: "90vh",
            overflowY: "auto",
            }}>
          <IconButton
            onClick={handleClose}
            sx={{ position: 'absolute', top: 10, right: 10, color: 'black',backgroundColor:"gray" }}
          >
            <CloseIcon />
          </IconButton>
          <img src={selectedImage} alt="Selected"  style={{width: "auto",
        height: "51vh",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",}}/>
        </Box>
      </Modal> */}
      </>
    )
}

export default ServicesCard;